import { Component, OnDestroy, OnInit } from '@angular/core';
import { BreadcrumbService } from '../services/breadcrumb.service';
import { Subscription } from 'rxjs';
import { MenuItem } from 'primeng/api';

import { AccountService } from '../services/account.service';

@Component({
  selector: 'app-breadcrumb',
  templateUrl: './app.breadcrumb.component.html',
})
export class AppBreadcrumbComponent implements OnDestroy, OnInit {
  subscription: Subscription;
  items: MenuItem[];
  clock: number = Date.now();
  //nom: string = '';

  constructor(
    public breadcrumbService: BreadcrumbService,
    private accountService: AccountService,
  ) {
    this.subscription = breadcrumbService.itemsHandler.subscribe(response => {
      this.items = response;
    });
  }

  ngOnInit() {
    // this.getUtilisateurInfo();

    setInterval(() => {
      this.clock = Date.now();
    }, 1000);
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  //getUtilisateurInfo() {
  //  let user = this.accountService.getUtilisateurAngular();
  //  if (user) {
  //    this.nom = user.NomToDisplay;
  //  }
  //  else {
  //    this.nom = '';
  //    setTimeout(() => {
  //      this.getUtilisateurInfo();
  //    }, 1000);
  //  }
  //}
}
